module.exports = __webpack_public_path__ + "static/affinity-6bc8d40b408b7b1512296f9a82d4a8a4.png";